module.exports = __webpack_public_path__ + "img/circle-microphone-lines.f6a22785.svg";